<div class="custom-icon-color" [ngStyle]="{ height: height, width: width }">
  <svg
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 25 25"
    width="100%"
  >
    <use
      [attr.xlink:href]="'assets/img/login/icons/login-cards.svg#' + iconName"
    ></use>
  </svg>
</div>
